import React, { useEffect } from 'react';
import { DialogProvider } from 'muibox';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

/* Core CSS required for Ionic components to work properly */
// import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
// import '@ionic/react/css/normalize.css';
// import '@ionic/react/css/structure.css';
// import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
// import '@ionic/react/css/padding.css';
// import '@ionic/react/css/float-elements.css';
// import '@ionic/react/css/text-alignment.css';
// import '@ionic/react/css/text-transformation.css';
// import '@ionic/react/css/flex-utils.css';
// import '@ionic/react/css/display.css';

/* Theme variables */
// import './theme/variables.css';
import SignInPage from './pages/auth/SignInPage';
import SignUpPage from './pages/auth/SignUpPage';
import RecoverPasswordPage from './pages/auth/RecoverPasswordPage';
import NuevoPasswordPage from './pages/auth/NuevoPasswordPage';
import PrivateRoute from 'services/auth/PrivateRoute';
import PrivateRoutesAdmin from 'services/auth/PrivateRoutesAdmin';
import RedirectToDashboard from 'services/auth/RedirectToDashboard';
import { MuiThemeProvider, CssBaseline, createMuiTheme } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";

import './App.css';

import {
  Plugins,
  PushNotification,
  PushNotificationToken,
  PushNotificationActionPerformed,
  Capacitor
} from '@capacitor/core';
import { StatusBar } from '@ionic-native/status-bar';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import PrivateRoutesCliente from 'services/auth/PrivateRoutesCliente';
import PrivateRoutesOperador from 'services/auth/PrivateRoutesOperador';
import EditarPerfilUsuarioPage from 'pages/auth/EditarPerfilUsuarioPage';
import ObleaPage from 'pages/obleas/ObleaPage';
// import { initializeApp } from 'firebase';

const Page404 = () => <div className=""><h1>Page404...</h1></div>;
const Page500 = () => <div className=""><h1>Page500...</h1></div>;
const AccesoDenegado = () => <div className=""><h1>No esta autorizado para acceder</h1></div>;

const theme = createMuiTheme({
  palette: {
    primary: { main: '#383086' },
    secondary: { main: '#fdd835' },
    success: { main: '#039678' },
    info: { main: '#039678' },
    background: {
      default: '#fff'
    },
  },
  props: {
    MuiButton: {
      variant: "contained",
      color: "primary",
    },
    MuiTextField: {
      variant: 'outlined',
      margin: 'dense',
      size: 'small',
    },
  }
});

const initPushNotifications = () => {
  const { PushNotifications } = Plugins;
  // Request permission to use push notifications
  // iOS will prompt user and return if they granted permission or not
  // Android will just grant without prompting
  PushNotifications.requestPermission().then(result => {
    if (result.granted) {
      // Register with Apple / Google to receive push via APNS/FCM
      PushNotifications.register();
    } else {
      // Show some error
    }
  });

  // On success, we should be able to receive notifications
  PushNotifications.addListener('registration',
    (token: PushNotificationToken) => {
      console.log('Push registration success, token: ' + token.value);
      // alert('Push registration success, token: ' + token.value);
    }
  );

  // Some issue with our setup and push will not work
  PushNotifications.addListener('registrationError',
    (error: any) => {
      alert('Error on registration: ' + JSON.stringify(error));
    }
  );

  // Show us the notification payload if the app is open on our device
  PushNotifications.addListener('pushNotificationReceived',
    (notification: PushNotification) => {
      alert('Push received: ' + JSON.stringify(notification));
    }
  );

  // Method called when tapping on a notification
  PushNotifications.addListener('pushNotificationActionPerformed',
    (notification: PushNotificationActionPerformed) => {
      alert('Push action performed: ' + JSON.stringify(notification));
    }
  );
}

const App: React.FC = () => {
  // const operadores = useOperadores();
  useEffect(() => {
    const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');
    if (isPushNotificationsAvailable) {
      initPushNotifications();
    }
    // set status bar to white
    StatusBar.backgroundColorByHexString('#292362');
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
        <DialogProvider>
          <CssBaseline>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
              <Switch>
                <Route path="/login" component={SignInPage} />
                <Route path="/registrarse" component={SignUpPage} />
                <Route path="/recuperar-password" component={RecoverPasswordPage} />
                <Route path="/nuevo-password" component={NuevoPasswordPage} />
                <Route path="/editar/perfil" component={EditarPerfilUsuarioPage} />
                <Route path="/obleas/:id" component={ObleaPage} />
                <Route path="/404" component={Page404} />
                <Route path="/500" component={Page500} />
                <Route path="/denegado" component={AccesoDenegado} />
                {/* <Route path="/certificados/obleas" component={PrivateRoutes} /> */}
                <PrivateRoute path="/admin" component={PrivateRoutesAdmin} roles={["admin"]} />
                <PrivateRoute path="/cliente" component={PrivateRoutesCliente} roles={["cliente"]} />
                <PrivateRoute path="/operador" component={PrivateRoutesOperador} roles={["operador"]} />
                {/* componente para redireccionar al dashboard dependiendo cada role */}
                <RedirectToDashboard />
              </Switch>
            </BrowserRouter>
          </CssBaseline>
        </DialogProvider>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};

export default App;
